import React, { forwardRef } from 'react'
import { SvgIcon, SvgIconProps } from '@mui/material'

const ChevronUp = forwardRef<SVGSVGElement, SvgIconProps>(
  function ChevronUp(props, ref) {
    return (
      <SvgIcon ref={ref} {...props}>
        <path d="M5.82 15.74a1 1 0 001.42-.06l4.76-5.2 4.76 5.2a1 1 0 001.48-1.36l-5.5-6-.04-.02-.02-.04c-.06-.05-.13-.08-.2-.11-.03-.03-.06-.06-.1-.07A1 1 0 0012 8a1 1 0 00-.37.08c-.05.01-.08.04-.12.07-.06.03-.13.06-.19.11l-.02.04-.04.02-5.5 6a1 1 0 00.06 1.42" />
      </SvgIcon>
    )
  },
)

export default ChevronUp
